module.exports = __webpack_public_path__ + "static/media/5.7e96a608.jpg";